<template>
  <div :class="$options.name" class="tw:h-fit tw:flex tw:flex-col tw:gap-3">
    <div v-if="showProgress" class="tw:mb-4 tw:w-[10rem]">
      <EdroneProgressBar :value="progressValue" type="default" :badge="false" class="progress-bar-transition" />
    </div>
    <div>
      <h2 :class="`${titleClass} tw:m-0 tw:flex tw:items-center `">
        <template v-if="!$slots.title">{{ title }}</template>
        <!-- Use this slot for custom title content or prop "title" -->
        <slot v-if="!title" name="title" />
      </h2>
      <p v-if="desc" :class="`${descClass} tw:!text-default-700 tw:!m-0 tw:pt-1`">
        {{ desc }}
      </p>
    </div>
    <div v-if="hasLinkSlot" :class="`${$options.name}__links tw:heading-2`">
      <!-- @slot DEPRECATED. No longer in Design System. -->
      <slot name="links" />
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";
import EdroneProgressBar from "./EdroneProgressBar.vue";

export default defineComponent({
  name: "EdroneHeader",
  components: {
    EdroneProgressBar,
  },
  props: {
    /**
     * Title of the header. Use this prop or slot "title" for custom title content.
     */
    title: {
      type: String,
      required: false,
      default: "",
    },
    desc: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String as PropType<"h1" | "h2" | "h3" | "h4">,
      default: "h1",
    },
    showProgress: {
      type: Boolean,
      default: false,
    },
    currentStep: {
      type: Number,
      default: undefined,
    },
    totalSteps: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
    hasLinkSlot(): boolean {
      return !!this.$slots.links;
    },
    progressValue(): number | undefined {
      if (!this.currentStep || !this.totalSteps) {
        return undefined;
      }
      return Math.round((this.currentStep / this.totalSteps) * 100);
    },
    titleClass() {
      switch (this.$props.type) {
        case "h1":
          return "tw:heading-1";
        case "h2":
          return "tw:heading-2";
        case "h3":
          return "tw:heading-3";
        case "h4":
          return "tw:body-2--bold";
        default:
          return "tw:heading-1";
      }
    },
    descClass() {
      switch (this.$props.type) {
        case "h1":
          return "tw:body-1";
        case "h2":
          return "tw:body-2";
        case "h3":
          return "tw:body-2";
        case "h4":
          return "tw:caption";
        default:
          return "tw:body-1";
      }
    },
  },
});
</script>

<style scoped>
.progress-bar-transition :deep(.EdroneProgressBar__bar) {
  transition: width 400ms ease-out;
}
</style>
